// tiptap's markdown serializer leaves two artifacts in the body it hands us.
// Neither is anything the author typed, and both reach recipients verbatim,
// so they are cleaned off before the body is stored.

// A Shift+Enter line break serializes as CommonMark's hard-break syntax —
// a trailing backslash. None of the surfaces a broadcast reaches implement
// it (Slack renders mrkdwn, Teams an adaptive card, email its own HTML), so
// recipients see a literal "\" at the end of those lines. The newline alone
// carries the break everywhere, so drop the backslash.
function stripHardBreakBackslashes(markdown: string): string {
  return markdown.replace(/\\(\r?\n)/g, "$1");
}

// Every text node is HTML-escaped on the way out of getMarkdown(), so
// "Settings > General" is serialized as "Settings &gt; General". Markdown
// decodes character references, which is why Slack and the portal still
// showed ">", but a surface that re-escapes does not: the email template's
// html.escape turned it into "&amp;gt;" and an adaptive-card TextBlock
// never decodes at all, so email and Teams both showed the entity.
//
// "&amp;" is deliberately left alone — the serializer does not escape "&",
// so a body that reaches us with "&amp;" in it meant that text.
function decodeAngleBrackets(markdown: string): string {
  return markdown.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
}

// Idempotent: a body that has already been through this has no backslashes
// or entities left to strip, which is what lets the editor compare against
// it and the clone path re-run it on a stored body.
export function normalizeEditorMarkdown(markdown: string): string {
  return decodeAngleBrackets(stripHardBreakBackslashes(markdown));
}
